import React, { useCallback, useState } from 'react';
import TextArea from 'react-textarea-autosize';
import classnames from 'classnames';

// TODO Review use of this class by reading https://lets-do-this.atlassian.net/browse/LDS-42
import { GLOBAL_FORM_STYLES_CLASS } from '@/globalClasses';

import { Button, KIND, SIZE } from '@letsdothis/lds/lib/Button';

import {
  SEGMENT_EVENTS,
  trackUserInteraction,
} from '../../../../utils/tracking';
import { openUrlInNewTab } from '../../../../utils/window';
import { askQuestionContainer } from '../../styles.module.css';

const getTypeformLink = ({ eventId, question }) =>
  `https://lets-do-this.typeform.com/to/Rm7gGD?event_id=${eventId}&faq_question=${question}`;

const CustomQuestionSubmit = ({
  customLinkGenerator,
  eventId,
  footer,
  name,
  placeholder,
  title,
  trackingPrefix,
}) => {
  const [questionInputValue, setQuestionInputValue] = useState('');
  const [inputEnterLogged, setInputEnterLogged] = useState(false);

  const onQuestionInputChange = useCallback(
    (event) => {
      if (!inputEnterLogged) {
        const inputName = 'question_input';
        trackUserInteraction(SEGMENT_EVENTS.INPUT_ENTERED, {
          name: `${trackingPrefix}_${inputName}`,
          shortName: inputName,
          source: trackingPrefix,
        });
      }
      setQuestionInputValue(event.target.value ?? '');
      setInputEnterLogged(true);
    },
    [setQuestionInputValue, inputEnterLogged, setInputEnterLogged],
  );

  const onQuestionSubmit = useCallback(() => {
    if (!questionInputValue) return;
    const formName = 'ask_question';
    trackUserInteraction(SEGMENT_EVENTS.FORM_SUBMITTED, {
      name: `${trackingPrefix}_${formName}`,
      shortName: formName,
      source: trackingPrefix,
      question: questionInputValue,
    });
    setQuestionInputValue('');
    setInputEnterLogged(false);
    openUrlInNewTab(getTypeformLink({ eventId, question: questionInputValue }));
  }, [eventId, questionInputValue]);

  return (
    <div className={classnames(askQuestionContainer, GLOBAL_FORM_STYLES_CLASS)}>
      <div>{title}</div>
      <TextArea
        name={name}
        placeholder={placeholder}
        onChange={onQuestionInputChange}
        value={questionInputValue}
      />
      {!customLinkGenerator ? (
        <Button
          size={SIZE.small}
          kind={KIND.secondary}
          onClick={onQuestionSubmit}
        >
          Submit
        </Button>
      ) : (
        customLinkGenerator(onQuestionSubmit)
      )}
      {footer}
    </div>
  );
};

export default CustomQuestionSubmit;
